import { render } from "./lista_ventas_revendedor.vue?vue&type=template&id=3a28f0d2"
import script from "./lista_ventas_revendedor.vue?vue&type=script&lang=js"
export * from "./lista_ventas_revendedor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__